module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "linespace",
    attrs: {
      "id": "epigraph"
    }
  }), _vm._v(" "), _c('p', {
    staticClass: "ep"
  }, [_vm._v("Zvino kana ruoke rwako rworudyi richikugumbura rudimure ururase nokuti zvinotova nane kwauri kuti mutezo wako mumwe chete ufe panokuti muviri wako wose upinde mumoto usinggadzimi")]), _vm._v(" "), _c('p', {
    staticClass: "epc"
  }, [_vm._v("(Matthew 5:30. Shona Bible)")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-bd661e1e","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/epigraph.vue
// module id = 72
// module chunks = 0